import { render, staticRenderFns } from "./Publishment.vue?vue&type=template&id=a848f47a&scoped=true&"
import script from "./Publishment.vue?vue&type=script&lang=ts&"
export * from "./Publishment.vue?vue&type=script&lang=ts&"
import style0 from "./Publishment.vue?vue&type=style&index=0&id=a848f47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a848f47a",
  null
  
)

export default component.exports